import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.EmplyApplicationForm),
  () => import('./EmplyApplicationForm'),
  (EmplyApplicationForm) => {
    ComponentUtil.binder(Hooks.EmplyApplicationForm, EmplyApplicationForm);
  },
);
